import { EmptyState, GhostRows } from '../../common/EmptyState'

const EmptyNotificationView = () => (
    <EmptyState preview={<GhostRows variant="notifications" />} text="You're all caught up." />
)

export default EmptyNotificationView
